/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Field_Project_Instructions_Q3_C4Inputs */



/**
* | output |
* | --- |
* | "Formal German business register" |
*
* @param {Uno_Field_Project_Instructions_Q3_C4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_field_project_instructions_q3_c4 = /** @type {((inputs?: Uno_Field_Project_Instructions_Q3_C4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Field_Project_Instructions_Q3_C4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Förmliches Deutsch, Sie-Form")
	return /** @type {LocalizedString} */ ("Formal German business register")
});